const ConsentForms = () => {
  return <div>ConsentForms</div>;
};

export default ConsentForms;
